module.exports = __webpack_public_path__ + "static/media/Baltoy_gaussian2.5fd6cea3.png";